import { Controller } from '@hotwired/stimulus';
import { ApideckVault } from '@apideck/vault-js';
import { getCsrfToken } from '../utilities/csrf';

export default class ApiDeckController extends Controller {
  static values = {
    sessionUrl: String,
  };

  async sessionToken() {
    const response = await fetch(this.sessionUrlValue, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authenticity_token: getCsrfToken(),
      },
      credentials: 'same-origin',
    });
    if (!response.ok) {
      throw new Error('Could not get session token');
    }

    const { token } = await response.json();
    return token;
  }

  async open(event) {
    event.preventDefault();

    ApideckVault.open({
      token: await this.sessionToken(),
      unifiedApi: 'hris',
    });
  }
}
